import { useState } from 'react';
import VtexCheckbox from '../../../styleguide/VtexCheckbox';
import { useNewsletterCheckboxConfirmation } from '../hooks/useNewsletterCheckboxConfirmation';

const NewsletterCheckboxConfirmationContainer = () => {
	const [isChecked, setIsChecked] = useState(false);
	const { blockClass, checkboxLabel, componentId } = useNewsletterCheckboxConfirmation();

	const renderClass = () => {
		return blockClass && `confirmationCheckboxContainer--${blockClass}`;
	};

	return (
		<div data-selection={componentId} className={`confirmationCheckboxContainer ${renderClass()}`}>
			<VtexCheckbox
				id={'newsletter-checkbox'}
				name={'newsletter-checkbox'}
				checked={isChecked}
				onChange={() => setIsChecked(!isChecked)}
				label={checkboxLabel || 'Eu aceito receber essa newsletter.'}
			/>
		</div>
	);
};

export default NewsletterCheckboxConfirmationContainer;
